import { makeStyles } from "@material-ui/core";
import photo1 from "../../../../assets/sectionThree1.png";
import card1 from "../../../../assets/card1.png";
import card2 from "../../../../assets/card2.png";
import card3 from "../../../../assets/card3.png";
import card4 from "../../../../assets/card4.png";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  thirdSection: {
    position: "relative",
    height: "150vh",
    marginBottom: "20vh",
    display: "grid",
    [breakpoints.up("xl")]: {
      height: "110vh",
      marginBottom: "10vh",
    },
  },
  backgroundOne: {
    backgroundColor: "#E6E2FE",
    width: "60%",
    height: "75%",
    position: "absolute",
    zIndex: 0,
    padding: "4% 0 4% 0%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    textAlign: "left",
  },
  backgroundTwo: {
    backgroundColor: "#EDF8F3",
    width: "60%",
    height: "80%",
    position: "absolute",
    right: 0,
    top: "15vh",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    [breakpoints.up("xl")]: {
      height: "70%",
    },
  },
  img1: {
    backgroundImage: `url(${photo1})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "absolute",
    zIndex: 2,
    width: "100%",
    height: "70%",
    top: "-50vh",
    [breakpoints.up("xl")]: {
      height: "80%",
    },
  },
  title1: {
    fontWeight: "bold",
    fontSize: "50px",
    lineHeight: "100%",
    color: "	#404040",
    textShadow: " 4px 4px 30px rgba(150, 150, 150, 0.53)",
    width: "30%",
    marginLeft: "80px",
  },
  title2: {
    fontWeight: "bold",
    fontSize: "50px",
    lineHeight: "100%",
    alignSelf: "right",
    color: "	#404040",
    textShadow: " 4px 4px 30px rgba(150, 150, 150, 0.53)",
    marginBottom: "170px",
    marginLeft: "80px",
  },
  cards: {
    width: "100%",
    justifySelf: "center",
    position: "absolute",
    zIndex: "3",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "auto auto auto",
    justifyItems: "center",
  },
  productCard: {
    gridColumn: "2/3",
    width: "70%",
    position: "relative",
    top: spacing(-10),
  },
  giftCard1: {
    gridColumn: "1/2",
    width: "70%",
    position: "relative",
    bottom: "-40%",
    [breakpoints.up("xl")]: {
      bottom: "-55%",
    },
  },
  giftCard2: {
    gridColumn: "2/3",
    width: "70%",
    [breakpoints.up("xl")]: {
      position: "relative",
      bottom: "-10%",
    },
  },
  giftCard3: {
    gridColumn: "3/4",
    width: "70%",
    position: "relative",
    bottom: "-10%",
    [breakpoints.up("xl")]: {
      position: "relative",
      bottom: "-25%",
    },
  },
  moreInfo: {
    gridColumn: "3/4",
    justifySelf: "end",
    position: "relative",
    bottom: "-250%",
    right: "15%",
    [breakpoints.up("xl")]: {
      bottom: "-350%",
    },
  },
  btn: {
    textTransform: "none!important",
    textDecoration: "none!important",
    fontFamily: "Source Sans Pro !important",
    fontStyle: "normal !important",
    fontWeight: "bold !important",
    fontSize: "16px !important",
  },
  spacer: {
    height: "30px",
    width: "100%",
    backgroundColor: "white",
  },
}));

export default useStyles;
